// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function StandardPages(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: "Standard Pages",
                      className: "px-5 py-6 border-b border-gray-300 text-darkcharcoal font-bold text-xl"
                    }),
                JsxRuntime.jsx("div", {
                      className: "p-8"
                    })
              ]
            });
}

var make = StandardPages;

exports.make = make;
/* react/jsx-runtime Not a pure module */
